import { createJsonMemoryAccessors } from '@/services/storage'

import type { AIConfig, AIHistoryEntry, AIHistoryType } from '../types'
import { DEFAULT_AI_CONFIG } from '../types'

const HISTORY_KEY = 'masterhub.ai.history.v1'
const CONFIG_KEY = 'masterhub.ai.config.v1'

type Slot = 'history' | 'config'

const memory: Record<Slot, unknown> = {
  history: null,
  config: null,
}

const { readJson, writeJson } = createJsonMemoryAccessors(memory)

export function resetAIMemory(): void {
  memory.history = null
  memory.config = null
}

export class AIHistoryRepository {
  list(): AIHistoryEntry[] {
    return readJson(HISTORY_KEY, 'history', [])
  }

  add(entry: Omit<AIHistoryEntry, 'id' | 'createdAt'> & { type: AIHistoryType }): AIHistoryEntry {
    const next: AIHistoryEntry = {
      ...entry,
      id: crypto.randomUUID(),
      createdAt: new Date().toISOString(),
    }
    writeJson(HISTORY_KEY, 'history', [next, ...this.list()].slice(0, 100))
    return next
  }

  clear(): void {
    writeJson(HISTORY_KEY, 'history', [])
  }
}

export class AIConfigRepository {
  get(): AIConfig {
    return readJson(CONFIG_KEY, 'config', DEFAULT_AI_CONFIG)
  }

  save(config: AIConfig): AIConfig {
    writeJson(CONFIG_KEY, 'config', config)
    return config
  }
}

export const aiHistoryRepository = new AIHistoryRepository()
export const aiConfigRepository = new AIConfigRepository()
